import { Toaster } from "sonner";
import { getSubdomainPage } from "@/subdomains/pages";

const slug = process.env.REACT_APP_SUBDOMAIN;

export default function SubdomainRoot() {
  const Page = slug ? getSubdomainPage(slug) : null;

  if (!Page) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-50">
        <p className="text-zinc-600 text-center max-w-md px-6">
          Invalid subdomain build. Set REACT_APP_SUBDOMAIN to one of: leadscoring, metals, agriculture, mining, realty, aiservices, precast
        </p>
      </div>
    );
  }

  return (
    <>
      <Page />
      <Toaster position="bottom-right" richColors closeButton />
    </>
  );
}
